import { render } from "./DemographicReportParametres.vue?vue&type=template&id=d7bcae9c"
import script from "./DemographicReportParametres.vue?vue&type=script&lang=js"
export * from "./DemographicReportParametres.vue?vue&type=script&lang=js"

import "./DemographicReportParametres.vue?vue&type=style&index=0&id=d7bcae9c&lang=css"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__